import { NavigateFunction } from "react-router-dom";

import {
  ILeaveParticipantAction,
  IUserAllowParticipantAction,
} from "@/types/auth.types";
import {
  ALLOW_USER,
  CANDIDATE_JOINED,
  END_INTERVIEW_FOR_ALL,
  GET_USER_STATUS,
  GRACEFUL_SHUTDOWN,
  JOIN_INTERVIEW,
  LEAVE_INTERVIEW,
  START_INTERVIEW,
} from "../constants/ActionTypes";

export const getUserStatus = (interviewSlug: string, skipRedirect = false) => ({
  type: GET_USER_STATUS,
  interviewSlug,
  skipRedirect,
});

export const startInterview = (
  interviewSlug: string,
  navigate: NavigateFunction,
  fromInterviewFeedback = false,
) => ({
  type: START_INTERVIEW,
  interviewSlug,
  navigate,
  fromInterviewFeedback,
});

export const joinInterview = (
  participantType: string,
  interviewSlug: string,
  navigate: NavigateFunction,
  name?: string,
  email?: string,
  otp?: string,
) => ({
  type: JOIN_INTERVIEW,
  payload: {
    participantType,
    interviewSlug,
    navigate,
    name,
    email,
    otp,
  },
});

export const leaveInterview = (
  interviewSlug: string,
  navigate: NavigateFunction,
) => ({
  type: LEAVE_INTERVIEW,
  payload: {
    interviewSlug,
    navigate,
  },
});

export const endInterviewForAllAction = (
  payload: ILeaveParticipantAction["payload"],
): ILeaveParticipantAction => ({
  type: END_INTERVIEW_FOR_ALL,
  payload,
});

export const candidateJoinedAction = () => ({
  type: CANDIDATE_JOINED,
});

export const allowUserAction = (
  candidateEmail: string,
  candidateSlug: string,
  interviewSlug: string,
): IUserAllowParticipantAction => ({
  type: ALLOW_USER,
  payload: {
    candidateEmail,
    candidateSlug,
    interviewSlug,
  },
});

export const gracefulShutdownAction = () => ({
  type: GRACEFUL_SHUTDOWN,
});
